export default "__VITE_ASSET__Bs_In6HC__"